import { gsap,ScrollTrigger,ScrollToPlugin,Back,Elastic,Circ,Expo,Sine,Linear} from 'gsap/all';
/*================================

Zoom Class

================================*/
export class Zoom {
    constructor() {
        this.isZoomFlag = false;
        this.wrapper = document.querySelector('.wrapper');
        this.zoomArea = document.querySelector('.zoom');
        this.btnZoom = document.querySelector('.js-zoom');
        this.pageRightPrev = document.querySelector('.js-page-right-prev');
        this.pageLeftPrev  = document.querySelector('.js-page-left-prev');
        this.pageRightNext = document.querySelector('.js-page-right-next');
        this.pageLeftNext  = document.querySelector('.js-page-left-next');
        this.maxScaleNum = 2.5;
        this.currentScaleNum = 1;
        this.targetX;
        this.targetY;
        this.initX;
        this.initY;
        this.moveX;
        this.moveY;
        this.sp = 0.3;
        this.onDragMouseDownEvent = this.onDragMouseDown.bind(this);
        this.onDragMouseMoveEvent = this.onDragMouseMove.bind(this);
        this.onDragMouseUpEvent = this.onDragMouseUp.bind(this);
        this.onDragTouchStartEvent = this.onDragTouchStart.bind(this);
        this.onDragTouchMoveEvent = this.onDragTouchMove.bind(this);
        this.onDragTouchEndEvent = this.onDragTouchEnd.bind(this);
        this.dragDis = 0;
        this.init();
    }

    //初期設定
    init() {
       this.setOperation();
       this.setPinchInOut();

        this.btnZoom.addEventListener('click',() => {
            if(this.isZoom) this.zoomout();
            else {
                const x = this.wrapper.clientWidth / 2;
                const y = this.wrapper.clientHeight / 2;
                this.zoomin(x,y);
            }

        });




    }

    set dragDistance(val) {
        this.dragDis = val;
    }

    get dragDistance() {
        return this.dragDis;
    }

    set isZoom(val) {
        this.isZoomFlag = val;

    }

    get isZoom() {
        return this.isZoomFlag;

    }


    /*=======================================

    ボタンでのズームイン

    =======================================*/
    zoomin(x,y) {
        const obj = this.getPosition(x,y,this.maxScaleNum);
        gsap.set([this.pageLeftNext,this.pageLeftPrev,this.pageRightNext,this.pageRightPrev],{opacity:0});
        gsap.to(this.zoomArea,{
            scale: this.maxScaleNum,
            x: obj.x,
            y: obj.y,
            duration: this.sp
        });
        this.isZoom = true;
        this.btnZoom.classList.add('out');
        this.currentScaleNum = this.maxScaleNum;

        this.dragStart();
    }



    /*=======================================

    ズームアウト

    =======================================*/
    zoomout() {
        gsap.set([this.pageLeftNext,this.pageLeftPrev,this.pageRightNext,this.pageRightPrev],{opacity:1});
        gsap.to(this.zoomArea,{
            scale: 1,
            x: 0,
            y: 0,
            duration: this.sp
        });
        this.isZoom = false;
        this.btnZoom.classList.remove('out');
        this.currentScaleNum = 1;
        this.dragEnd();

    }

    /*=======================================

    ポジション取得

    =======================================*/
    getPosition(x,y,s) {
        const obj = {
            x: -(x * s - x),
            y: -(y * s - y)
        }
        return obj;

    }

    /*=======================================

    最大値での中心点からの距離を取得

    =======================================*/
    getPositionRect(x,y) {
        const zr = this.zoomArea.getBoundingClientRect();
        const xper = (Math.abs(zr.x) + x) / zr.width;
        const yper = (Math.abs(zr.y) + y) / zr.height;

        const xPos = this.wrapper.clientWidth * xper;
        const yPos = this.wrapper.clientHeight * yper;

        //console.log('拡大時のX='+(Math.abs(zr.x) + x) ,'\n原寸時のX='+xPos,'\n拡大時のY='+(Math.abs(zr.y) + y),'\n原寸時のY='+yPos,'\n---------------')
        return {x:xPos,y:yPos}
    }


    /*=======================================

    各操作設定

    =======================================*/
    setOperation() {
        let isDoubleClick = false;

        const onDoubleClick = (e) => {
            const targetX = e.type === 'touchstart' ? e.touches[0].pageX : e.pageX;
            const targetY = e.type === 'touchstart' ? e.touches[0].pageY : e.pageY;
            if(e.type === 'touchstart' && e.touches.length > 1 || e.target.tagName === 'BUTTON' || e.target.classList.contains('turn-area')) return;
            //this.getPositionRect(targetX,targetY);


            if(isDoubleClick) {
                isDoubleClick = false;
                if(this.isZoom) {
                    this.zoomout();
                } else {
                    this.zoomin(targetX,targetY);

                    e.stopPropagation();
                }
                return;
            }
            isDoubleClick = true;
            setTimeout(() => {
                isDoubleClick = false;

            },350);

        }

        if(!('ontouchstart' in window)) this.zoomArea.addEventListener('mousedown',onDoubleClick);
        this.zoomArea.addEventListener('touchstart',onDoubleClick,{passive: false});
    }


    /*=======================================

    ドラッグ移動

    =======================================*/
    dragStart() {
        this.wrapper.classList.add('grab');
        this.dragDistance = 0;
        this.zoomArea.addEventListener('mousedown',this.onDragMouseDownEvent);
        this.zoomArea.addEventListener('touchstart',this.onDragTouchStartEvent);
    }

    dragEnd() {
        this.wrapper.classList.remove('grab');
        this.dragDistance = 0;
        this.zoomArea.removeEventListener('mousedown',this.onDragMouseDownEvent);
        this.zoomArea.removeEventListener('touchstart',this.onDragTouchStartEvent);
    }

    setDragPosition(x,y) {
        const minX = this.wrapper.clientWidth - (this.wrapper.clientWidth * this.currentScaleNum);
        const minY = this.wrapper.clientHeight - (this.wrapper.clientHeight * this.currentScaleNum)
        let mx = this.targetX - (this.initX - x);
        let my = this.targetY - (this.initY - y);

        this.dragDistance = Math.sqrt(Math.pow(this.moveX - this.initX,2) + Math.pow(this.moveY - this.initY,2));

        if(mx < minX) mx = minX;
        if(mx > 0) mx = 0;

        if(my < minY) my = minY;
        if(my > 0) my = 0;

        gsap.set(this.zoomArea,{
            x: mx,
            y: my
        });

    }

    getDragPosition() {
        const rect = this.zoomArea.getBoundingClientRect();
        return rect;
    }

    //マウス操作
    onDragMouseDown(e) {
        e.preventDefault();
        this.targetX = this.getDragPosition().x;
        this.targetY = this.getDragPosition().y;
        this.initX = e.pageX;
        this.initY = e.pageY;
        this.wrapper.classList.add('grabbing');
        this.dragDistance = 0;
        document.addEventListener('mousemove',this.onDragMouseMoveEvent);
        document.addEventListener('mouseup',this.onDragMouseUpEvent);
    }

    onDragMouseMove(e) {
        e.preventDefault();
        this.moveX = e.pageX;
        this.moveY = e.pageY;
        this.setDragPosition(this.moveX,this.moveY);
    }
    onDragMouseUp(e) {
        e.preventDefault();
        this.wrapper.classList.remove('grabbing');
        document.removeEventListener('mousemove',this.onDragMouseMoveEvent);
        document.removeEventListener('mouseup',this.onDragMouseUpEvent);
    }

    //タッチ操作
    onDragTouchStart(e) {
        //e.stopPropagation();
        if(e.touches.length > 1) return;
        this.targetX = this.getDragPosition().x;
        this.targetY = this.getDragPosition().y;
        this.initX = e.touches[0].pageX;
        this.initY = e.touches[0].pageY;
        this.dragDistance = 0;
        this.wrapper.classList.add('grabbing');
        document.addEventListener('touchmove',this.onDragTouchMoveEvent);
        document.addEventListener('touchend',this.onDragTouchEndEvent);
    }

    onDragTouchMove(e) {
        e.preventDefault();
        if(e.touches.length > 1) return;
        this.moveX = e.touches[0].pageX;
        this.moveY = e.touches[0].pageY;
        this.setDragPosition(this.moveX,this.moveY);
    }
    onDragTouchEnd(e) {
        this.wrapper.classList.remove('grabbing');
        document.removeEventListener('touchmove',this.onDragTouchMoveEvent);
        document.removeEventListener('touchend',this.onDragTouchEndEvent);
    }


    /*=======================================

    ピンチインアウト操作

    =======================================*/
    setPinchInOut() {
        let isPinch = false;
        let initDis = 0;
        let initScale = 1;
        let startX = 0;
        let startY = 0;
        let centerX = 0;
        let centerY = 0;

        //ピンチ間の中心点を取得
        const getCenterPoint = (e) => {
            const touches = e.touches;
            const x1 = touches[0].pageX;
            const y1 = touches[0].pageY;

            const x2 = touches[1].pageX;
            const y2 = touches[1].pageY;

            const xPos = Math.min(x1,x2);
            const yPos = Math.min(y1,y2);

            const pos = {
                x: Math.abs((x1 - x2) / 2) + xPos,
                y: Math.abs((y1 - y2) / 2) + yPos
            }
            return pos;
        }

        const getDistance = (e) => {
            const touches = e.touches;
            const x1 = touches[0].pageX;
            const y1 = touches[0].pageY;

            const x2 = touches[1].pageX;
            const y2 = touches[1].pageY;

            return Math.sqrt(Math.pow(x2 - x1,2) + Math.pow(y2 - y1,2));
        }


        const onPinchStart = (e) => {
            //e.preventDefault();
            e.stopPropagation();

            if(e.touches.length > 1 && !isPinch) {
                e.preventDefault();
                isPinch = true;
                initDis = getDistance(e);
                initScale = this.currentScaleNum;
                /*centerX = getCenterPoint(e).x - this.zoomArea.getBoundingClientRect().x;
                centerY = getCenterPoint(e).y- this.zoomArea.getBoundingClientRect().y;*/
                const pos = this.getPositionRect(getCenterPoint(e).x,getCenterPoint(e).y);
                startX = getCenterPoint(e).x;
                startY = getCenterPoint(e).y;
                centerX = pos.x;
                centerY = pos.y;
                //console.log('現在のx='+centerX,'\n改修のx='+pos.x,'現在のy='+centerY,'\n改修のy='+pos.y,'\n-------------')
                document.addEventListener('touchmove',onPinchMove);
                document.addEventListener('touchend',onPinchEnd);
                //console.log('-------------------')
            }

        }

        const onPinchMove = (e) => {
            e.preventDefault();
            if(e.touches.length > 1) {


                this.currentScaleNum = (getDistance(e) / initDis)  * initScale;

                const minX = this.wrapper.clientWidth - (this.wrapper.clientWidth * this.currentScaleNum);
                const minY = this.wrapper.clientHeight - (this.wrapper.clientHeight * this.currentScaleNum)

                if(this.currentScaleNum <= 1) this.currentScaleNum = 1;
                else if(this.currentScaleNum >= this.maxScaleNum) this.currentScaleNum = this.maxScaleNum;
                let mx = -(centerX * this.currentScaleNum - centerX - (startX - centerX));
                let my = -(centerY * this.currentScaleNum - centerY - (startY - centerY));


                if(mx < minX) mx = minX;
                if(mx > 0) mx = 0;

                if(my < minY) my = minY;
                if(my > 0) my = 0;
               // const pos = this.getPosition(centerX,centerY,this.currentScaleNum);
                gsap.set(this.zoomArea,{
                    scale: this.currentScaleNum,
                    x: mx,
                    y: my
                });
            }
        }
        const onPinchEnd = (e) => {
            e.preventDefault();
            isPinch = false;
            if(this.currentScaleNum >1) {
                this.isZoom = true;
                this.btnZoom.classList.add('out');
                this.dragStart();
            } else {
                this.isZoom = false;
                this.btnZoom.classList.remove('out');
                this.dragEnd();
            }
            document.removeEventListener('touchmove',onPinchMove);
            document.removeEventListener('touchend',onPinchEnd);

        }
        this.wrapper.addEventListener('touchstart',onPinchStart);
    }


}